export default function permission() {
  const getPermissions = applyDocument => {
    const perm = {
      can_update: true,
      can_add: true,
      can_change_state: true,
    }
    const letterPermissions = applyDocument.applied_doc_permissions ? applyDocument.applied_doc_permissions : {}
    return {
      ...perm,
      ...letterPermissions,
    }
  }
  const canUpdate = applyDocument => getPermissions(applyDocument).can_update
  const canChangeState = applyDocument => getPermissions(applyDocument).can_change_state

  const canAdd = applyDocument => getPermissions(applyDocument).can_add

  return {
    canAdd,
    canUpdate,
    canChangeState,
  }
}
